






































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
// Data
import {
  ApiOperators,
  FILTER_ARRAY_VALUES_SEPARATOR,
  FILTER_OPERATORS,
  FILTER_TYPES_WITH_ARRAY_VALUES,
  FilterOperators,
  FilterTypes,
  ROUTER_OPERATOR_SEPARATOR,
  SUBFILTER_CONCAT_CHAR
} from "@/data/table";
// Types
import {
  ISegmentFilter,
  ISegmentForm,
  ISegmentSubFilter
} from "@/models/segments";
import { ISegmentTypes } from "@/data/enums/segments";
import { IFilter, IOperator } from "@/models/tables";
import HasValidation from "@/mixins/HasValidation";
import {
  apiOperatorString,
  filterValueToApiValue,
  getOperatorFromValueAndApiOperator
} from "@/helpers/table";

@Component({
  components: {
    "segment-filter": () =>
      import("@/components/app/admin/segments/segmentFilter.vue")
  }
})
export default class SegmentParams extends Mixins(HasValidation) {
  @Prop({ required: true })
  public form!: ISegmentForm;

  @Prop({ required: true })
  public segmentType!: ISegmentTypes;

  @Prop({ required: true })
  public segmentFilters!: IFilter[];

  @Prop({ required: true })
  public disabled!: boolean;

  public usedFilters: ISegmentFilter[] = [];
  public filterOperators: IOperator[] = FILTER_OPERATORS();

  public created() {
    const segmentFilter = this.$_.get(this.form, "params.filter");
    if (segmentFilter) {
      this.decodeParams(segmentFilter);
    }
  }

  public addNewFilter(filterKey = "") {
    if (this.hasEmptyValues) {
      return;
    }

    const availableFilter: IFilter = this.findAvailableFilter(filterKey);
    this.usedFilters.push({
      key: availableFilter.key,
      type: availableFilter.type,
      subfilters: [
        {
          operator: this.findFirstOperator(availableFilter.type),
          value: this.isFilterWithArrayValue(availableFilter.type) ? [] : null
        }
      ]
    });
  }

  public isFilterWithArrayValue(type: FilterTypes) {
    return FILTER_TYPES_WITH_ARRAY_VALUES.includes(type);
  }

  public findAvailableFilter(filterKey: string): IFilter {
    if (filterKey !== "") {
      return this.$_.find(this.segmentFilters, ["key", filterKey]) as IFilter;
    }
    return this.$_.find(
      this.segmentFilters,
      filter => !this.$_.find(this.usedFilters, ["key", filter.key])
    ) as IFilter;
  }

  public findFirstOperator(filterType: FilterTypes): FilterOperators {
    const operator = this.$_.find(this.filterOperators, filterOperator =>
      filterOperator.types.includes(filterType)
    ) as IOperator;

    return operator.key;
  }

  public findUsedFilterIndex(filterKey: string): number {
    return this.$_.findIndex(this.usedFilters, ["key", filterKey]);
  }

  public onFilterRemoved(filterKey: string) {
    this.usedFilters.splice(this.findUsedFilterIndex(filterKey), 1);
  }

  public decodeParams(segmentFilter) {
    this.$_.forEach(segmentFilter, (filterValue, filterKey) => {
      const filterParams: any[] = filterKey.split(ROUTER_OPERATOR_SEPARATOR);

      const filter = this.$_.find(this.segmentFilters, [
        "key",
        filterParams[0]
      ]);
      if (!filter) {
        return;
      }
      const subfilters: ISegmentSubFilter[] = [];
      if (filterParams.length > 1 && filterParams[1] === ApiOperators.LIKE) {
        this.$_.forEach(
          filterValue.split(SUBFILTER_CONCAT_CHAR),
          subfilterValue => {
            subfilters.push(
              this.buildSubfilter(subfilterValue, filterParams[1], filter.type)
            );
          }
        );
      } else {
        subfilters.push(
          this.buildSubfilter(filterValue, filterParams[1], filter.type)
        );
      }

      this.usedFilters.push({
        key: filterParams[0],
        type: filter.type,
        subfilters
      });
    });
  }

  public get categoriseSegmentFilters() {
    const categories: string[] = [];
    this.$_.forEach(this.segmentFilters, segmentFilter => {
      if (!segmentFilter.group || categories.includes(segmentFilter.group)) {
        return;
      }
      categories.push(segmentFilter.group);
    });

    return this.$_.map(categories, categoryName => {
      return {
        group: categoryName,
        filters: this.$_.filter(this.segmentFilters, ["group", categoryName])
      };
    });
  }

  public buildSubfilter(
    filterValue: string,
    apiOperator: ApiOperators,
    filterType: FilterTypes
  ): ISegmentSubFilter {
    const value = filterValue.replace(/%/g, "");
    return {
      operator: getOperatorFromValueAndApiOperator(filterValue, apiOperator),
      value: this.isFilterWithArrayValue(filterType)
        ? value.split(FILTER_ARRAY_VALUES_SEPARATOR)
        : value
    };
  }

  public onFilterChanged(filterKey: string, filter: ISegmentFilter) {
    this.$set(this.usedFilters, this.findUsedFilterIndex(filterKey), filter);
  }

  public codeParams() {
    const filters: object = {};
    this.$_.forEach(this.usedFilters, filter => {
      filters[
        `${filter.key}${apiOperatorString(filter.subfilters[0].operator)}`
      ] = this.$_.map(filter.subfilters, subfilter =>
        filterValueToApiValue(subfilter.operator, filter.type, subfilter.value)
      ).join(SUBFILTER_CONCAT_CHAR);
    });
    return filters;
  }

  public get hasEmptyValues() {
    return this.$_.some(this.usedFilters, usedFilter => {
      return this.$_.some(usedFilter.subfilters, subfilter =>
        this.$_.isEmpty(subfilter.value)
      );
    });
  }

  @Watch("usedFilters", { deep: true })
  public usedFiltersChanged() {
    if (this.hasEmptyValues) {
      return;
    }

    this.$emit("paramsChanged", this.codeParams());
  }

  // ???
  @Watch("canAddNewFilter", { immediate: true })
  public canAddNewFilterChanged() {
    this.$emit("validFilterParams", !this.hasEmptyValues);
  }
}
